import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { EssenceBalance } from '@sorare/core/src/components/balance/EssenceBalance';
import { GemsBalance } from '@sorare/core/src/components/commonGame/GemsBalance';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSeriesNav } from '@sorare/core/src/hooks/commonGame/useSeriesNav';
import { SUPPORTED_CARD_SETS } from '@sorare/core/src/lib/cardSets';
import { getCommonCardShardsCount } from '@sorare/core/src/lib/currentUser';
import { COMMON_GAME_SET } from '@sorare/core/src/set';

type Props = {
  cardSetSlugs?: readonly string[];
};
export const SeriesBalance = ({
  cardSetSlugs = SUPPORTED_CARD_SETS,
}: Props) => {
  const { currentUser } = useCurrentUserContext();
  const isSimplifiedNav = useSeriesNav();

  return (
    <Horizontal>
      <GemsBalance balance={currentUser?.gemsBalances[0]?.amount || 0} />
      {cardSetSlugs.map(
        slug =>
          (slug === COMMON_GAME_SET.cardSet.activeSlug ||
            (slug === COMMON_GAME_SET.cardSet.baseSlug &&
              !isSimplifiedNav)) && (
            <EssenceBalance
              key={slug}
              value={getCommonCardShardsCount(currentUser, slug) || 0}
              rarity={Rarity.common}
              cardSetSlug={slug}
            />
          )
      )}
    </Horizontal>
  );
};
